import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

const SignIn = () => {
  const { login, loading } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.email || !form.password) return setError('Email and password are required');
    const result = await login(form.email, form.password);
    if (result.success) {
      navigate('/');
    } else {
      setError(result.message);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-brand">
          <span className="auth-logo">⇄</span>
          <h1>SkillSwap</h1>
          <p>Sign in to your account</p>
        </div>

        {error && <div className="auth-error">{error}</div>}

        <form className="auth-fields" onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              type="email"
              placeholder="your@email.com"
              value={form.email}
              onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
              autoFocus
            />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              placeholder="Your password"
              value={form.password}
              onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
            />
          </div>

          <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%', marginTop: 8 }} disabled={loading}>
            {loading ? <><span className="loading-spinner" /> Signing in…</> : 'Sign In'}
          </button>
        </form>

        <div className="auth-demo">
          <p style={{ fontSize: 13, color: 'var(--gray-400)', marginBottom: 8 }}>Demo accounts</p>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {[
              { email: 'alice@demo.com', password: 'demo123' },
              { email: 'bob@demo.com', password: 'demo123' }
            ].map((cred, i) => (
              <button
                key={i}
                className="btn btn-ghost btn-sm"
                type="button"
                onClick={() => setForm(cred)}
              >
                {cred.email.split('@')[0]}
              </button>
            ))}
          </div>
        </div>

        <p className="auth-switch">
          Don't have an account? <Link to="/signup">Create one</Link>
        </p>
      </div>

      <div className="auth-visual">
        <div className="auth-visual-content">
          <h2>Exchange knowledge,<br />grow together.</h2>
          <p>Connect with people who have what you want to learn — and teach what you know best.</p>
          <div className="auth-visual-chips">
            {['Python → Spanish', 'Guitar → Yoga', 'Design → React', 'Chess → Cooking', 'Photography → Finance'].map((chip, i) => (
              <span key={i} className="visual-chip">{chip}</span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
